/**
 * Authentication configuration
 */

export interface AuthConfig {
  inactivityTimeoutMinutes: number;
  sessionStorageKey: string;
}

export const authConfig: AuthConfig = {
  // Auto-logout after 10 minutes of inactivity (configurable)
  inactivityTimeoutMinutes: 10,
  
  // Session storage key for token
  sessionStorageKey: 'auth_token'
};

// Get auth configuration
export const getAuthConfig = (): AuthConfig => {
  return authConfig;
};
